import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'capitalize' })
export class CapitalizePipe implements PipeTransform {
  transform(value: any) {
      return value.charAt(0).toUpperCase() + value.slice(1);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/pipes/capitalize.pipe.ts